import type { SyncTransport } from '@orbit-mind/sync-engine';
import type { Result, AppError } from '@orbit-mind/shared-types';
import { createHttpTransport, withAttachments, syncAttachments } from '@orbit-mind/sync-engine';
import type { MapDocument } from '@orbit-mind/domain';
import { localStorageLayer, storageAccount } from './storage';

export function createFileSync(getDocument?: () => MapDocument): {
  transport: SyncTransport;
  sync: (document: MapDocument) => Promise<Result<void, AppError>>;
} {
  const options = {
    fetch: globalThis.fetch.bind(globalThis),
    accountId: storageAccount(),
    store: localStorageLayer().attachments,
  };
  return {
    transport: withAttachments(createHttpTransport(options), {
      ...options,
      ...(getDocument === undefined ? {} : { getDocument }),
    }),
    sync: (document: MapDocument) =>
      syncAttachments({ ...options, mapId: document.map.id, document }),
  };
}
